import { useDispatch } from 'react-redux'
import * as Admins from '../contracts/access'
import { setMaintainers, setMaintainerStatus } from '../modules/access/actions'
import { ethers } from 'ethers'

export interface IAccessContract {
  addMaintainer: (account: string) => Promise<void>
  removeMaintainer: (account: string) => Promise<void>
  isMaintainer: (account: string) => Promise<void>
  getMaintainers: () => Promise<void>
}

const initContract = (provider: ethers.BrowserProvider, account: string) => {
  if (provider) {
    return new ethers.Contract(
      Admins.address,
      Admins.abi as ethers.InterfaceAbi,
      provider,
    )
  }
}

const useAccessContract = (
  provider: ethers.BrowserProvider,
  account: string,
): IAccessContract => {
  const dispatch = useDispatch()
  const contract = initContract(provider, account)

  async function addMaintainer(account: string) {
    return await contract?.voteForAddMaintainer(account)
  }

  async function removeMaintainer(account: string) {
    return await contract?.voteFroRemoveMaintainer(account)
  }

  async function isMaintainer(account: string) {
    if (account) {
      const isAdmin = await contract?.isMaintainer(account)
      dispatch(setMaintainerStatus(isAdmin))
    }
  }

  async function getMaintainers() {
    const admins: Array<string> = await contract?.getMaintainers()

    dispatch(setMaintainers(admins))
  }

  return { addMaintainer, removeMaintainer, isMaintainer, getMaintainers }
}

export default useAccessContract
